import IconNameEnum from "constants/IconNameEnum";
import IAction from "models/IAction";
import IStore from "models/IStore";
import moment from "moment";
import React from "react";
import { Col, Form, ProgressBar, Row } from "react-bootstrap";
import { connect, DispatchProp } from "react-redux";
import LookUpAction from "stores/lookup/LookUpAction";
import AdministrativeCategoryModel from "stores/lookup/models/AdminisrativeCategoryModel";
import CanaliModel from "stores/lookup/models/CanaliModel";
import AgentiProvvModel from "stores/lookup/models/AgentiProvvModel";
import DurataModel from "stores/lookup/models/DurataModel";
import LookupManagementModel from "stores/lookup/models/LookupManagementModel";
import SegmentiModel from "stores/lookup/models/SegmentiModel";
import TipoProdottoModel from "stores/lookup/models/TipoProdottoModel";
import TipoRichiestaModel from "stores/lookup/models/TipoRichiestaModel";
import CercaAction from "stores/ricerca/CercaAction";
import { ISearchSimulazioneRequest } from "stores/ricerca/CercaEffects";
import CercaSimulazioneFormModel from "stores/ricerca/models/CercaSimulazioneFormModel";
import FormatUtility from "utilities/FormatUtility";
import ValidationUtility, { ValidationContainer } from "utilities/ValidationUtility";
import BaseModal from "views/components/base-content/BaseModal";
import BasePageCard from "views/components/base-content/BasePageCard";
import BaseAutoComplete from "views/components/base-form/BaseAutoComplete";
import BaseButton from "views/components/base-form/BaseButton";
import BaseDate from "views/components/base-form/BaseDate";
import BaseIcon from "views/components/base-form/BaseIcon";
import BaseInput from "views/components/base-form/BaseInput";
import CercaSimulazioneTabella from "./CercaSimulazioneTabella";
import FunctionEnum from "../../constants/FunctionEnum";

interface IProps {}

interface IState {
    readonly isDownloading: boolean;
    readonly progressDownload: number;
    readonly validationContainer: ValidationContainer<CercaSimulazioneFormModel>;
}

interface IRouteParams {}

interface IStateToProps {
    readonly isRequesting: boolean;
    readonly isUtenteDirezione: boolean;
    readonly administrativeCategory: AdministrativeCategoryModel[]; //replace with agente
    readonly tipoRichiesta: TipoRichiestaModel[];
    readonly canali: CanaliModel[];
    readonly agentiProvv: AgentiProvvModel[];
    readonly segmenti: SegmentiModel[];
    readonly durata: DurataModel[];
    readonly isIE: boolean;
    readonly isSafari: boolean;
    readonly atc: LookupManagementModel[];
    readonly formModel: CercaSimulazioneFormModel;
    readonly productTypes: TipoProdottoModel[];
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: false,
    isUtenteDirezione: state.utente.profilo.tipoCdc == "D",
    administrativeCategory: state.lookup.administrativeCategory,
    durata: state.lookup.durata,
    atc: state.lookup.management,
    tipoRichiesta: state.lookup.tipiRichieste,
    isIE: state.config.isIE,
    isSafari: state.config.isSafari,
    canali: state.lookup.canali,
    agentiProvv: state.lookup.agentiProvv,
    segmenti: state.lookup.segmenti,
    formModel: state.cerca.cercaSimulazioneForm,
    productTypes: state.lookup.productTypes,
});

export class CercaSimulazione extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            progressDownload: 0,
            isDownloading: false,
            validationContainer: ValidationUtility.setValidationContainer<CercaSimulazioneFormModel>(
                new CercaSimulazioneFormModel({})
            ),
        } as IState;
    }

    private hasUnmounted = false;
    private validationSchema = ValidationUtility.getSchemaCercaSimulazione();
    private formRef: React.RefObject<HTMLFormElement> = React.createRef<HTMLFormElement>();
    private downloadFileRef: React.RefObject<HTMLAnchorElement> = React.createRef<HTMLAnchorElement>();

    public componentWillUnmount() {
        this.hasUnmounted = true;
        this.props.dispatch(CercaAction.resetCercaSimulazione());
    }

    componentDidMount() {
        const { formModel, isUtenteDirezione } = this.props;
        this.props.dispatch(LookUpAction.administrativeCategoryGet());
        if (isUtenteDirezione) {
            this.props.dispatch(LookUpAction.resetCanali());
            this.props.dispatch(LookUpAction.canaliGet(Number(formModel.agente), isUtenteDirezione));
        }
        this.props.dispatch(LookUpAction.agentiProvvGet());
        this.props.dispatch(LookUpAction.productTypesGet());

        if (formModel.dataCreazioneA && formModel.dataCreazioneDa) {
            this.getLastSimulations();
        }
    }

    private getLastSimulations = async () => {
        const { formModel } = this.props;

        let dataCreazioneDa = formModel.dataCreazioneDa
            ? moment.utc(formModel.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = formModel.dataCreazioneA ? moment.utc(formModel.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchSimulazioneRequest = {
            pageNumber: 1,
            pageSize: 20,
            creationDateFrom: dataCreazioneDa,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
        };
        await this.props.dispatch(CercaAction.searchSimulation(request));
    };

    private handleCerca = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        this.onSubmitHandler(event);
    };

    private onChangeHandler = async (name: string, value: string | number | boolean | Date) => {
        const { tipoRichiesta, formModel, atc, isUtenteDirezione } = this.props;

        let formValues = new CercaSimulazioneFormModel(formModel);

        formValues = FormatUtility.updateNestedPropertyValue<CercaSimulazioneFormModel>(formValues, name, value);

        if (name === "atc") {
            const selectedAtc = atc.find((item: LookupManagementModel) => item.key === value);
            const cliente = selectedAtc?.idAdmCategory?.toString() || "";

            formValues = FormatUtility.updateNestedPropertyValue<CercaSimulazioneFormModel>(
                formValues,
                "tipoCliente",
                cliente
            );
        }

        if (name === "tipoCliente" && formValues.canale && formValues.tipoRichiesta) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(formValues.tipoRichiesta),
                    Number(value),
                    Number(formValues.canale),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }
        if (name === "canale" && formValues.tipoCliente && formValues.tipoRichiesta) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(formValues.tipoRichiesta),
                    Number(formValues.tipoCliente),
                    Number(value),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }

        if (name === "tipoRichiesta" && formValues.tipoCliente && formValues.canale) {
            this.props.dispatch(
                LookUpAction.segmentiGet(
                    Number(value),
                    Number(formValues.tipoCliente),
                    Number(value),
                    Number(
                        ValidationUtility.verificaFn(FunctionEnum.FN_BPP)
                            ? formModel.agente.toString().split("|")[0]
                            : formModel.agente
                    )
                )
            );
        }

        formValues = FormatUtility.updateNestedPropertyValue<CercaSimulazioneFormModel>(formValues, name, value);
        console.log(value);

        if (this.hasUnmounted === false) {
            await this.props.dispatch(CercaAction.setCercaSimulazioneForm(formValues));
        }
    };

    private onBlurHandler = async (name: string) => {
        let validationContainer = await ValidationUtility.validateSchema<CercaSimulazioneFormModel>(
            this.validationSchema,
            this.state.validationContainer,
            this.props.formModel,
            name,
            undefined
        );

        if (this.hasUnmounted === false) {
            this.setState({
                validationContainer: validationContainer,
            });
        }
    };

    private onSubmitHandler = async (
        event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        event.preventDefault();
        let validationContainer = await ValidationUtility.validateSchema<CercaSimulazioneFormModel>(
            this.validationSchema,
            this.state.validationContainer,
            this.props.formModel,
            undefined,
            undefined
        );
        if (this.hasUnmounted === false) {
            this.setState({
                validationContainer: validationContainer,
            });
        }

        if (ValidationUtility.checkValidity(validationContainer) === true) {
            this.submit();
        } else {
            if (this.hasUnmounted === false) {
                this.setState({}, () => {
                    ValidationUtility.scrollToFirstError<CercaSimulazioneFormModel>(
                        validationContainer,
                        "cercaSimulazione."
                    );
                });
            }
        }
    };

    private submit = async () => {
        let data = new CercaSimulazioneFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }
        const request: ISearchSimulazioneRequest = {
            pageNumber: 1,
            pageSize: 20,
            sortParam: data.colName!,
            sortAsc: data.direction === "A" ? true : false,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            name: data.denominazione ? data.denominazione : undefined,
            creationDateFrom: dataCreazioneDa,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            // idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            atc: data.atc ? Number(data.atc) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            instalment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo.replace(",", ".").replace(".", "")) : undefined,
            idProductType: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
        };
        if (this.hasUnmounted === false) {
            if (data.numSimulazione) {
                await this.props.dispatch(CercaAction.serachSimulazioneById(Number(data.numSimulazione)));
            } else {
                await this.props.dispatch(CercaAction.searchSimulation(request));
            }
        }
    };

    private onInputChangeHandlerAutocomplete = async (name: string, value: string) => {
        value?.length > 2 && (await this.props.dispatch(LookUpAction.lookupManagementGet(value)));
    };

    private requestDownloadDocumento = async (
        request: ISearchSimulazioneRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob> => {
        return await this.props
            .dispatch(CercaAction.simulazioniExportExcel(request, progressHandler))
            .then((response: Blob) => response);
    };

    private downloadDocumento = () => {
        let data = new CercaSimulazioneFormModel({ ...this.props.formModel });

        let dataCreazioneDa = data.dataCreazioneDa
            ? moment.utc(data.dataCreazioneDa, "DD/MM/YYYY").toISOString()
            : undefined;
        let dataCreazioneA = data.dataCreazioneA ? moment.utc(data.dataCreazioneA, "DD/MM/YYYY") : undefined;
        if (dataCreazioneA) {
            const today = new Date();
            dataCreazioneA.set({
                hour: today.getHours(),
                minute: today.getMinutes(),
                second: today.getSeconds(),
            });
        }

        const request: ISearchSimulazioneRequest = {
            pageNumber: 1,
            pageSize: 20,
            sortParam: data.colName,
            sortAsc: data.direction === "A" ? true : false,
            requestType: data?.tipoRichiesta! ? Number(data?.tipoRichiesta!) : undefined,
            name: data.denominazione ? data.denominazione : undefined,
            creationDateFrom: dataCreazioneDa,
            creationDateTo: dataCreazioneA ? dataCreazioneA.toISOString() : undefined,
            idAgent: data.agente ? data.agente : undefined,
            idChannel: data.canale ? Number(data.canale) : undefined,
            idSegment: data.segmento ? Number(data.segmento) : undefined,
            idProduct: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
            atc: data.atc ? Number(data.atc) : undefined,
            idAdministrativeCategory: data.tipoCliente ? Number(data.tipoCliente) : undefined,
            instalment: data.rata ? parseFloat(data.rata) : undefined,
            duration: data.durata ? Number(data.durata) : undefined,
            amount: data.importo ? Number(data.importo) : undefined,
            idProductType: data.tipoProdotto ? Number(data.tipoProdotto) : undefined,
        };

        if (this.hasUnmounted === false) {
            this.setState({
                isDownloading: true,
            });
        }
        const updateProgress = (progress: number) => {
            if (this.hasUnmounted === false) {
                this.setState({
                    progressDownload: progress,
                });
            }
        };

        this.requestDownloadDocumento(request, updateProgress).then((response: Blob) => {
            if (response && response instanceof Blob && this.downloadFileRef.current) {
                this.downloadFileRef.current.href = window.URL.createObjectURL(response);
                let ext = ".xlsx";
                this.downloadFileRef.current.download = "Elenco simulazioni" + ext;
                this.downloadFileRef.current.click();
            }
            if (this.hasUnmounted === false) {
                this.setState({
                    isDownloading: false,
                    progressDownload: 0,
                });
            }
        });
    };

    public render(): JSX.Element {
        const {
            tipoRichiesta,
            administrativeCategory,
            canali,
            agentiProvv,
            segmenti,
            durata,
            atc,
            formModel,
            productTypes,
        } = this.props;

        const { isDownloading, progressDownload, validationContainer } = this.state;
        //const agents: any = [];

        const disabled = formModel.numSimulazione !== "";

        return (
            <Form className="h-100" id="ricerca" ref={this.formRef} noValidate onSubmit={this.onSubmitHandler}>
                <BasePageCard
                    isIE={false}
                    isSafari={false}
                    isRequesting={false}
                    headerIcon={IconNameEnum.RicercaGrigio}
                    headerTitle="Cerca simulazione"
                >
                    <Row className="align-items-center mb-3">
                        <Col sm={12} md={4} xl={4}>
                            <BaseInput
                                controlId="cercaSimulazione.numSimulazione"
                                floatingLabel={true}
                                placeholder="---"
                                type="text"
                                name="numSimulazione"
                                value={formModel.numSimulazione}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                customFormat="numbers"
                                formatOnDigit={true}
                                label="N&#176; simulazione"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseInput
                                controlId="cercaSimulazione.denominazione"
                                floatingLabel={true}
                                placeholder="---"
                                type="text"
                                name="denominazione"
                                value={formModel.denominazione}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                disabled={disabled}
                                label="Denominazione simulazione"
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-3">
                        <Col className="align-items-center" sm={12} md={4} xl={4}>
                            <BaseDate
                                controlId="cercaSimulazione.dataCreazioneDa"
                                floatingLabel={true}
                                placeholder="gg/mm/aaaa"
                                name="dataCreazioneDa"
                                value={formModel.dataCreazioneDa}
                                showCalendar={true}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                onBlurHandler={this.onBlurHandler}
                                isInvalid={validationContainer.dataCreazioneDa.invalid}
                                error={validationContainer.dataCreazioneDa.message}
                                disabled={disabled}
                                label="Data creazione da"
                            />
                        </Col>
                        <Col className="align-items-center " sm={12} md={4} xl={4}>
                            <BaseDate
                                controlId="cercaSimulazione.dataCreazioneA"
                                floatingLabel={true}
                                placeholder="gg/mm/aaaa"
                                name="dataCreazioneA"
                                value={formModel.dataCreazioneA}
                                showCalendar={true}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                onBlurHandler={this.onBlurHandler}
                                isInvalid={validationContainer.dataCreazioneA.invalid}
                                error={validationContainer.dataCreazioneA.message}
                                max={moment().toDate()}
                                disabled={disabled}
                                label="Data creazione a"
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-3">
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                sortOptions={true}
                                controlId="cercaSimulazione.agente"
                                value={formModel.agente}
                                onChangeHandler={this.onChangeHandler}
                                placeholder="Selezionare..."
                                isInvalid={false}
                                error={""}
                                floatingLabel={true}
                                name="agente"
                                required={false}
                                options={FormatUtility.getOptionValuesFromAgentiProvvLookup(agentiProvv)}
                                disabled={disabled}
                                label="Agente Produttore"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                sortOptions={true}
                                controlId="cercaSimulazione.canale"
                                name="canale"
                                floatingLabel={true}
                                placeholder="Selezionare..."
                                value={formModel.canale}
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(canali)}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                disabled={disabled}
                                label="Canale"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                sortOptions={true}
                                controlId="cercaSimulazione.segmento"
                                name="segmento"
                                floatingLabel={true}
                                placeholder="Selezionare..."
                                value={formModel.segmento}
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(segmenti)}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                disabled={disabled}
                                label="Segmento"
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-3">
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                sortOptions={true}
                                controlId="cercaSimulazione.tipoRichiesta"
                                value={formModel.tipoRichiesta}
                                onChangeHandler={this.onChangeHandler}
                                placeholder="Selezionare..."
                                isInvalid={false}
                                error={""}
                                floatingLabel={true}
                                name="tipoRichiesta"
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(tipoRichiesta)}
                                disabled={disabled}
                                label="Tipo richiesta"
                            />
                        </Col>
                        {!ValidationUtility.verificaFn(FunctionEnum.FN_BPP) && (
                            <Col sm={12} md={4} xl={4}>
                                <BaseAutoComplete
                                    sortOptions={true}
                                    controlId="cercaSimulazione.tipoProdotto"
                                    value={formModel.tipoProdotto}
                                    onChangeHandler={this.onChangeHandler}
                                    placeholder="Selezionare.."
                                    isInvalid={false}
                                    error={""}
                                    floatingLabel={true}
                                    name="tipoProdotto"
                                    required={false}
                                    options={FormatUtility.getOptionValuesFromLookup(productTypes)}
                                    disabled={disabled}
                                    label="Tipo prodotto"
                                />
                            </Col>
                        )}
                    </Row>
                    <Row className="align-items-center mb-3">
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                controlId="cercaSimulazione.atc"
                                name="atc"
                                searchInside={true}
                                floatingLabel={true}
                                placeholder="Ricercare..."
                                value={formModel.atc}
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(atc)}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                onInputChangeHandler={this.onInputChangeHandlerAutocomplete}
                                disabled={disabled}
                                label="ATC"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                sortOptions={true}
                                controlId="cercaSimulazione.tipoCliente"
                                value={formModel.tipoCliente}
                                onChangeHandler={this.onChangeHandler}
                                placeholder="Selezionare..."
                                isInvalid={false}
                                error={""}
                                floatingLabel={true}
                                name="tipoCliente"
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(administrativeCategory)}
                                disabled={disabled}
                                label="Tipologia Cliente"
                            />
                        </Col>
                    </Row>

                    <Row className="align-items-center mb-3 cerca-row pt-3 pb-3">
                        <Col sm={12} md={4} xl={4}>
                            <BaseInput
                                controlId="cercaSimulazione.rata"
                                value={formModel.rata}
                                onChangeHandler={this.onChangeHandler}
                                placeholder="---"
                                isInvalid={false}
                                error={""}
                                floatingLabel={true}
                                type="text"
                                name="rata"
                                required={false}
                                step={0.01}
                                customFormat="numberWithSeparators"
                                formatOnDigit={true}
                                append={<BaseIcon icon={IconNameEnum.Euro} />}
                                disabled={disabled}
                                label="Rata"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseAutoComplete
                                controlId="cercaSimulazione.durata"
                                value={formModel.durata?.toString() || ""}
                                onChangeHandler={this.onChangeHandler}
                                placeholder="---"
                                isInvalid={false}
                                error={""}
                                floatingLabel={true}
                                name="durata"
                                required={false}
                                options={FormatUtility.getOptionValuesFromLookup(durata)}
                                disabled={disabled}
                                label="Durata (mesi)"
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4}>
                            <BaseInput
                                controlId="cercaSimulazione.importo"
                                floatingLabel={true}
                                placeholder="---"
                                append={<BaseIcon icon={IconNameEnum.Euro} />}
                                type="text"
                                name="importo"
                                value={formModel.importo}
                                required={false}
                                onChangeHandler={this.onChangeHandler}
                                isInvalid={false}
                                error={""}
                                step={0.01}
                                customFormat="numberWithSeparators"
                                formatOnDigit={true}
                                disabled={disabled}
                                label="Importo"
                            />
                        </Col>
                    </Row>
                    <Row className="p-2 align-items-center">
                        {disabled && (
                            <Col sm={12} md={6}>
                                <span className="font-weight-bold">
                                    N<span>&#176;</span> simulazione valorizzato, gli altri filtri non verranno
                                    considerati.
                                </span>
                            </Col>
                        )}

                        <Col sm={12} md={disabled ? 6 : 12} className="text-right">
                            <BaseButton
                                label="Cerca"
                                icon={IconNameEnum.Cerca}
                                onClickHandler={this.handleCerca}
                                type="button"
                                color="blue"
                            />
                        </Col>
                    </Row>
                    <hr />

                    <CercaSimulazioneTabella onExportSimulazione={this.downloadDocumento} />
                </BasePageCard>
                <a ref={this.downloadFileRef} hidden className="d-none" href="" download=""></a>
                <BaseModal
                    show={isDownloading}
                    closeOnOutClick={false}
                    centered={true}
                    body={
                        <Row>
                            <Col className="text-center">
                                <h5 className="text-ecq-blue">Attendere</h5>
                                <Form.Label>Download in corso</Form.Label>
                                <ProgressBar
                                    animated
                                    min={0}
                                    max={100}
                                    now={progressDownload}
                                    label={progressDownload + "%"}
                                />
                            </Col>
                        </Row>
                    }
                />
            </Form>
        );
    }
}

export { CercaSimulazione as Unconnected };
export default connect(mapStateToProps)(CercaSimulazione);
